import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DialogService } from "primeng/dynamicdialog";
import { takeUntil } from "rxjs/operators";
import { ApiService } from '../../services/api.service';
import { UnsubscribeComponent } from "../../generals/Components";
import { ModulelogComponent } from "./modulelog/modulelog.component";
import { AdminModuleDetail } from "../../interfaces/interfaces";
import { GlobizFeedImportModuleComponent } from "./modulecomponents/globizfeedimportmodule/globizfeedimportmodule.component";
import { ProductSearchIndexerModuleComponent } from "./modulecomponents/productsearchindexermodule/productsearchindexer.module";
import { MailNotifierModuleComponent } from "./modulecomponents/mailnotifiermodule/mailnotifiermodule.module";
import { ProductPricingModuleComponent } from "./modulecomponents/productpricingmodule/productpricingmodule.component";
import { PaymentSimplepayModuleComponent } from "./modulecomponents/paymentsimplepay/paymentsimplepay.component";
import { FacebookCatalogModuleComponent } from "./modulecomponents/facebookcatalogmodule/facebookcatalogmodule.component";
import { GoogleMerchantModuleComponent } from "./modulecomponents/googlemerchantmodule/googlemerchantfeedmodule.component";

@Component({
    selector: 'app-module',
    templateUrl: './module.component.html',
    styleUrls: ['./module.component.scss']
})
export class ModuleComponent extends UnsubscribeComponent {

    id: number = null;
    module: AdminModuleDetail<any> = null;

    functionName: string = '';
    functionData: any = null;

    changed: boolean = false;
    hasConfig: boolean = false;

    @ViewChild('viewglobizfeedimportmodule') viewglobizfeedimportmodule: GlobizFeedImportModuleComponent = null;
    @ViewChild('viewproductsearchindexermodule') viewproductsearchindexermodule: ProductSearchIndexerModuleComponent = null;
    @ViewChild('viewmailnotifiermodule') viewmailnotifiermodule: MailNotifierModuleComponent = null;
    @ViewChild('viewproductpricingmodule') viewproductpricingmodule: ProductPricingModuleComponent = null;
    @ViewChild('viewpaymentsimplepay') viewpaymentsimplepay: PaymentSimplepayModuleComponent = null;
    @ViewChild('viewfacebookcatalogmodule') viewfacebookcatalogmodule: FacebookCatalogModuleComponent = null;
    @ViewChild('viewgooglemerchantmodule') viewgooglemerchantmodule: GoogleMerchantModuleComponent = null;

    constructor(
        private activatedRoute: ActivatedRoute,
        private apiService: ApiService,
        private dialogService: DialogService
    ) {
        super();
        const idString: string = this.activatedRoute.snapshot.paramMap.get('id');
        if (idString !== null) {
            this.id = parseInt(idString);
        }
        this.init();
    }

    init(): void {
        if (this.id !== null) {
            this.getModule();
        }
    }

    reload(): void {
        this.getModule();
    }

    getModule(): void {
        this.apiService.getModule(this.id).pipe(takeUntil(this.unsubscribe)).subscribe(({module}) => {
            this.module = module;
            console.log(this.module);
        });
    }

    changeEnableState(): void {
        this.apiService.enableModule(this.id, this.module.enabled).pipe(takeUntil(this.unsubscribe)).subscribe(() => {

        });
    }

    showLogDialog(): void {
        this.dialogService.open(ModulelogComponent, {
            header: 'Log - ' + this.module.title,
            data: {
                moduleId: this.module.id
            }
        });
    }

    callFunction(): void {
        if (this.functionName.length === 0) {
            this.functionData = null;
            return;
        }
        this.callFunctionWithName(this.functionName);
    }

    callFunctionWithName(functionName: string): void {
        this.apiService.moduleFunctionGet<any>(this.module.id, functionName).subscribe(({data}) => {
            this.functionData = data;
        });
    }

    configChanged(changed: boolean): void {
        this.changed = changed;
    }

    subModuleInited(): void {
        this.hasConfig = true;
    }

    saveConfig(): void {
        switch(this.module.moduleName) {
            case 'GLOBIZ_FEED_IMPORT': this.viewglobizfeedimportmodule.saveConfig(); break;
            case 'PRODUCT_SEARCH_INDEXER': this.viewproductsearchindexermodule.saveConfig(); break;
            case 'MAIL_NOTIFIER': this.viewmailnotifiermodule.saveConfig(); break;
            case 'PRODUCT_PRICING': this.viewproductpricingmodule.saveConfig(); break;
            case 'PAYMENT_SIMPLEPAY': this.viewpaymentsimplepay.saveConfig(); break;
            case 'FACEBOOK_CATALOG': this.viewfacebookcatalogmodule.saveConfig(); break;
            case 'GOOGLE_MERCHANT': this.viewgooglemerchantmodule.saveConfig(); break;
        }
    }
}